import { environment } from '../environments/environment';

export function isInsideIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function waitForHostToken(timeoutMs = 8000): Promise<any> {
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), timeoutMs);
    window.addEventListener('message', (event) => {
      if (!environment.allowedIframeOrigin?.includes(event.origin)) {
        return;
      }
      if (event.data?.type === 'AUTH_TOKEN') {
        clearTimeout(timer);
        resolve(event.data.payload);
      }
    });
    if (window.parent) {
      const parentOrigin = document.referrer ? new URL(document.referrer).origin : '';
      if (!environment.allowedIframeOrigin?.includes(parentOrigin)) {
        console.error('Origin not allowed');
        return;
      }
      window.parent.postMessage(
        {
          type: 'REQUEST_TOKEN',
          payload: {
            // scopes: environment.apiConfig.scopes,
          },
        },
        parentOrigin,
      );
    }
  });
}
